import axios from 'axios';

export const httpClient = axios.create({
  baseURL: window.__ENV__.VITE_API_BASE_URL || import.meta.env.VITE_API_BASE_URL
})